module.exports = __webpack_public_path__ + "media/ceremony_sound.592498b0.mp3";